import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import BtnShop from '../../BtnShop/BtnShop';
import ShowDiploma from '../../CourseSpecificInfo/ShowDiploma/ShowDiploma';

import classes from './UserInfo.module.css';

const UserInfo = () => {
  const dataCourse = useSelector(state => state.courseInfo);
  const userInfo = useSelector(state => state.userInfo);

  return (
    <>
      <div className={classes.buyContainer}>
        <aside className={classes.btnContainer}>
          <BtnShop />
          {dataCourse.missingActivities.length === 0 &&
            userInfo.data.usuario.length !== 0 && (
              <div className={classes.showDiplomacontainer}>
                <ShowDiploma
                  dataCertificate={dataCourse.userDegree}
                  titleCourse={dataCourse.data.nombre}
                />
              </div>
            )}
        </aside>
      </div>
    </>
  );
};

UserInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userAditionalTrack: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object
};

export default UserInfo;
